import { render, staticRenderFns } from "./ProcessPackingShipped.vue?vue&type=template&id=a60ccfaa&scoped=true&"
import script from "./ProcessPackingShipped.vue?vue&type=script&lang=js&"
export * from "./ProcessPackingShipped.vue?vue&type=script&lang=js&"
import style0 from "./ProcessPackingShipped.vue?vue&type=style&index=0&id=a60ccfaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60ccfaa",
  null
  
)

export default component.exports